import React, { useState } from "react";
import Sidebar from "../components/sidebar";
import Modal from "react-bootstrap/Modal";
import DealerTable from "./TestingDealertb";
import Form from "./Createform";
import Header from "../components/Header";
import { NavLink } from "react-router-dom";
import "./Dealers.css"; // Import the CSS file

function Dealers() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="Clients">
      <div className="main">
        {/* Button Container with Responsive Grid */}
        <div className="button-container">
          <button onClick={handleShow} className="AddClient">
            <i className="fa fa-user-plus" aria-hidden="true"></i> Add Reseller
          </button>
          <NavLink exact to="/dealer/details/free/" className="AddClient">
            More Details
          </NavLink>
          <NavLink exact to="/internet/dealers/fiber/fee" className="AddClient">
            Fiber Fee
          </NavLink>
          <NavLink exact to="/internet/dealers/infrastructure/fee" className="AddClient">
            Infrastructure Fee
          </NavLink>
        </div>

        {/* Modal for Adding Dealer */}
        <Modal show={show} onHide={handleClose} className="modal-lg">
          <Modal.Header closeButton>
            <Modal.Title>Add Client</Modal.Title>
          </Modal.Header>
          <Form parentFunction={handleClose} />
        </Modal>

        {/* Dealer Table */}
        <div className="testo">
          <DealerTable />
        </div>
      </div>
    </div>
  );
}

export default Dealers;

